/*
 * ██████╗ ██╗████████╗███████╗ █████╗  ██████╗████████╗ ██████╗ ██████╗ ██╗   ██╗
 * ██╔══██╗██║╚══██╔══╝██╔════╝██╔══██╗██╔════╝╚══██╔══╝██╔═══██╗██╔══██╗╚██╗ ██╔╝
 * ██████╔╝██║   ██║   █████╗  ███████║██║        ██║   ██║   ██║██████╔╝ ╚████╔╝
 * ██╔══██╗██║   ██║   ██╔══╝  ██╔══██║██║        ██║   ██║   ██║██╔══██╗  ╚██╔╝
 * ██████╔╝██║   ██║   ██║     ██║  ██║╚██████╗   ██║   ╚██████╔╝██║  ██║   ██║
 * ╚═════╝ ╚═╝   ╚═╝   ╚═╝     ╚═╝  ╚═╝ ╚═════╝   ╚═╝    ╚═════╝ ╚═╝  ╚═╝   ╚═╝
 *
 *
 * Copyright (c) Bitfactory GmbH. All rights reserved.
 * https://www.bitfactory.io
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are not permitted.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS
 * FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
 * COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT,
 * INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES INCLUDING,
 * BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
 * LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN
 * ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 * POSSIBILITY OF SUCH DAMAGE.
 */

import { observer } from 'mobx-react';
import { Box, Typography } from '@mui/material';
import React from 'react';
import { ChoiceViewUseStyles } from './ChoiceViewStyles';
import { ELEMENTS_TYPE } from '../../../../utils/elementFactory';

interface Props {
	options: string[] | undefined;
	selectedOption: string | undefined;
	type: ELEMENTS_TYPE;
}

export const SingleChoiceView = observer((props: Props) => {
	const { options, selectedOption, type } = props;
	const { classes } = ChoiceViewUseStyles();

	const isChecked = (text: string): boolean => {
		if (!!selectedOption && type === ELEMENTS_TYPE.ENTRY) {
			return selectedOption === text;
		}
		return false;
	};

	return (
		<Box className={classes.container}>
			{options &&
				options.map((text: string, index: number) => (
					<Box className={classes.box} key={'singleTextOption' + index}>
						{isChecked(text) ? (
							<Box className={`${classes.textSelectBox} ${classes.radioChecked}`}>
								<Box className={classes.radioCheckedInside} />
							</Box>
						) : (
							<Box className={`${classes.textSelectBox} ${classes.radioUnchecked}`} />
						)}
						<Typography className={classes.text}>{text}</Typography>
					</Box>
				))}
		</Box>
	);
});
